import {useEffect, useState} from 'react';
import {Canvas, FabricObject} from 'fabric';
import {ScaledDimensions} from '../utils/resize-utils';

export const useLiveScaledDimensions = (
    canvas: Canvas | null,
    element: FabricObject,
    getDimensions: (target: FabricObject) => ScaledDimensions
) => {
    // Panels show this override only while the user is actively resizing.
    const [override, setOverride] = useState<ScaledDimensions | null>(null);

    useEffect(() => {
        if (!canvas) return;

        const handleScaling = (e: any) => {
            if (e.target === element) {
                setOverride(getDimensions(e.target));
            }
        };
        const handleResizing = (e: any) => {
            if (e.target === element) {
                setOverride(getDimensions(e.target));
            }
        };

        const handleModified = (e: any) => {
            if (e.target === element) {
                setOverride(null);
            }
        };

        canvas.on('object:scaling', handleScaling);
        canvas.on('object:resizing', handleResizing);
        canvas.on('object:modified', handleModified);

        return () => {
            canvas.off('object:scaling', handleScaling);
            canvas.off('object:resizing', handleResizing);
            canvas.off('object:modified', handleModified);
        };
    }, [canvas, element, getDimensions]);

    return override;
};
